import React, { createContext, useContext } from "react";
import useSMSTokenTimer from "./useSMSTokenTimer";

const UserTokenTimerContext = createContext();

export const UpsellWidgetSMSTokenTimerProvider = ({ children }) => {
    const { resetTimer, remainingTime, getRemainingTimeText } = useSMSTokenTimer();
    return (
        <UserTokenTimerContext.Provider value={{ resetTimer, remainingTime, getRemainingTimeText }}>
            {children}
        </UserTokenTimerContext.Provider>
    );
};

export const useUpsellWidgetSMSTokenTimerContext = () => {
    const context = useContext(UserTokenTimerContext);
    if (!context) {
        throw new Error("timer must be used within a TimerProvider");
    }
    return context;
};